import { topics } from "@/mocks/chigua";

export default function TopicDirectory() {
  return (
    <section id="topic" className="w-full scroll-mt-20 py-14 md:py-20">
      <div className="mx-auto max-w-6xl px-4 md:px-6">
        <div className="mb-8 flex flex-col md:flex-row md:items-end md:justify-between gap-5">
          <div className="max-w-2xl">
            <p className="flex items-center gap-2 text-sm font-medium text-primary-600 mb-2">
              <span className="inline-block h-px w-8 bg-primary-400"></span>FEATURED SERIES
            </p>
            <h2 className="font-display text-2xl md:text-4xl font-bold text-foreground-950">
              专题目录 · <span className="text-primary-600">连续剧瓜田</span>
            </h2>
            <p className="mt-3 text-sm md:text-base text-foreground-600">
              适合追更的深度专题，像追剧一样逐期更新。挑一个你上头的，蹲下来慢慢看。
            </p>
          </div>
          <a
            href="#about"
            className="inline-flex items-center gap-1.5 whitespace-nowrap text-sm font-medium text-foreground-700 hover:text-primary-700"
          >
            查看完整专题列表
            <i className="ri-arrow-right-line"></i>
          </a>
        </div>

        <ul className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {topics.map((tp) => (
            <li key={tp.id}>
              <a
                href="#trending"
                className="group flex h-full flex-col overflow-hidden rounded-xl border border-background-200 bg-background-50 transition-all hover:-translate-y-1 hover:border-primary-300"
              >
                <div className="relative overflow-hidden">
                  <img
                    src={tp.image}
                    alt={tp.title + "专题封面"}
                    className="aspect-[8/5] w-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
                  />
                  <span
                    className={
                      "absolute left-3 top-3 inline-flex items-center gap-1.5 whitespace-nowrap rounded-full px-3 py-1 text-[11px] font-medium text-background-50 " +
                      tp.color
                    }
                  >
                    <i className="ri-flashlight-fill"></i>
                    {tp.badge}
                  </span>
                </div>
                <div className="flex flex-1 flex-col p-5">
                  <h3 className="font-display text-lg font-bold text-foreground-950 group-hover:text-primary-700 transition-colors">
                    {tp.title}
                  </h3>
                  <p className="mt-2 text-sm text-foreground-600 leading-relaxed">{tp.intro}</p>
                  <div className="mt-4 flex items-center justify-between border-t border-background-200 pt-3.5">
                    <span className="inline-flex items-center gap-1 text-xs text-foreground-500">
                      <i className="ri-folder-open-line text-primary-500"></i>
                      {tp.count}
                    </span>
                    <span className="inline-flex items-center gap-1 text-xs text-foreground-500">
                      <i className="ri-eye-line text-accent-600"></i>
                      {tp.views}
                    </span>
                  </div>
                </div>
              </a>
            </li>
          ))}
        </ul>
      </div>
    </section>
  );
}